import React, { useState, useEffect } from 'react';
import { List, Datagrid, TextField, EmailField } from 'react-admin';


export const LocalVaultList = props => (
	<List {...props} bulkActionButtons={false} >
		<Datagrid rowClick="show">
			<TextField source="name" />
			<TextField source="keyuuid" />
			<TextField source="type" />
		</Datagrid>
	</List>
);